import React from 'react'

export default function ImageView({doc, docName}) {
    return (
      <div className="cardStyle image-wrapper">
        <img className="hover-zoom" src={`data:image/jpg;base64,${doc}`} alt={docName} />
      </div>
    );
}
